import { MovimientoCartera } from '../services/carteraService';

export const NRO_TIPO_FORMULARIO_TRASPASO = '17';

export const TIPOS_DOCUMENTO_EXCLUIDOS_DEFAULT = [NRO_TIPO_FORMULARIO_TRASPASO];

export const getTipoFormularioKey = (mov: MovimientoCartera): string =>
  String(mov.nroTipoFormulario ?? '').trim() || '__sin_tipo__';

export const esMovimientoTraspasoCartera = (
  mov: Pick<MovimientoCartera, 'nroTipoFormulario'>
): boolean => String(mov.nroTipoFormulario ?? '').trim() === NRO_TIPO_FORMULARIO_TRASPASO;

export const getTiposDocumentoEnListado = (
  movimientos: MovimientoCartera[]
): { key: string; label: string }[] => {
  const map = new Map<string, string>();
  for (const mov of movimientos) {
    if (mov.nroFormulario === 0) continue;
    const key = getTipoFormularioKey(mov);
    if (!map.has(key)) {
      map.set(key, getTipoMovimientoLabel(mov));
    }
  }
  return Array.from(map.entries())
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es'));
};

export const filtrarMovimientosPorTipoDocumento = (
  movimientos: MovimientoCartera[],
  tiposExcluidos: string[]
): MovimientoCartera[] => {
  if (tiposExcluidos.length === 0) return movimientos;
  const excluidos = new Set(tiposExcluidos);
  return movimientos.filter((mov) => {
    if (mov.nroFormulario === 0) return true;
    return !excluidos.has(getTipoFormularioKey(mov));
  });
};

export const getTipoMovimientoLabel = (mov: MovimientoCartera): string => {
  if (mov.nroFormulario === 0) return 'Saldo Inicial';
  return mov.nombreTipoFormulario?.trim() || mov.nroTipoFormulario?.trim() || '-';
};

export const getComprobanteMovimientoLabel = (mov: MovimientoCartera): string => {
  if (mov.nroFormulario === 0) return '-';
  const comprobante =
    mov.letraSucNum?.trim() ||
    `${mov.letra?.trim() || ''}${mov.nroComprobante || ''}`.trim();
  if (!comprobante || comprobante === 'X-0000-00000000') return '-';
  return comprobante;
};
